import React, { createContext, useState, useContext } from "react";

// Create the context
export const AppContext = createContext();

// Create a provider component
export const AppProvider = ({ children }) => {
  const storedUser = JSON.parse(localStorage.getItem("user")) ?? null;
  const storedToken = localStorage.getItem("token") ?? null;

  const [User, setUser] = useState(storedUser);
  const [Token, setToken] = useState(storedToken);

  const [OpenDrawerFromAdminHeader, setOpenDrawerFromAdminHeader] =
    useState(null);

  return (
    <AppContext.Provider
      value={{
        User,
        setUser,
        Token,
        setToken,
        setOpenDrawerFromAdminHeader,
        OpenDrawerFromAdminHeader,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

// Custom hook to access context
export const useAppContext = () => useContext(AppContext);

//in this component we handle all data in the project using useContext!
